import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').factory('ShipperUser', shipperUserService);

    function shipperUserService(
        $resource,
        API_URL,
        storageService,
        APP_MEMORY_STORAGE_KEY,
        platformSettingsService
    ) {
        return $resource(
            API_URL.SHIPPER_USER,
            {},
            {
                loggedInShipperUser: {
                    method: 'GET',
                    url: API_URL.SHIPPER_USER
                },
                getShipperUser: {
                    method: 'GET',
                    url: API_URL.SHIPPER_USER + '/user/:id',
                    params: {
                        id: '@id'
                    }
                },
                assignments: {
                    method: 'GET',
                    url: API_URL.SHIPPER_USER + '/assignments',
                    isArray: true
                },
                assignment: {
                    method: 'GET',
                    url:
                        API_URL.SHIPPER_USER +
                        '/:shipperUserId/assignments/:id',
                    params: {
                        id: '@id'
                    }
                },
                changeShipperUserFromShipperAdmin: {
                    method: 'POST',
                    url:
                        API_URL.SHIPPER_USER +
                        '/changeShipperUserFromShipperAdmin'
                },
                deactivateShipperUserFromShipperAdmin: {
                    method: 'POST',
                    url:
                        API_URL.SHIPPER_USER +
                        '/deactivateShipperUserFromShipperAdmin'
                },
                getFutureShipperUser: {
                    method: 'GET',
                    url: API_URL.SHIPPER_USER + '/futureShipperUser/:shipperId',
                    params: {
                        shipperId: '@shipperId'
                    }
                },
                addAssignment: {
                    method: 'POST',
                    url: API_URL.SHIPPER_USER + '/:shipperUserId/assignments',
                    params: { shipperUserId: '@shipperUserId' }
                },
                deleteAssignment: {
                    method: 'DELETE',
                    url:
                        API_URL.SHIPPER_USER +
                        '/:shipperUserId/assignments/:tsoRefId',
                    params: {
                        tsoRefId: '@tsoRefId',
                        shipperUserId: '@shipperUserId'
                    }
                },
                getSettings: {
                    method: 'GET',
                    url: API_URL.SHIPPER_USER + '/settings/:setting',
                    params: {
                        setting: '@setting'
                    },
                    interceptor: {
                        response: function (res) {
                            if (!res.data) {
                                return res.data;
                            }

                            if (
                                platformSettingsService.isValidPlatformSettings(
                                    res.data
                                )
                            ) {
                                storageService.storeToLocal(
                                    APP_MEMORY_STORAGE_KEY.PLATFORM_SETTINGS,
                                    res.data
                                );
                            }

                            return res.data;
                        }
                    }
                },
                saveSettings: {
                    method: 'POST',
                    url: API_URL.SHIPPER_USER + '/settings/:setting',
                    params: {
                        setting: '@setting'
                    },
                    interceptor: {
                        response: function (res) {
                            if (!res.data) {
                                return res.data;
                            }

                            if (
                                platformSettingsService.isValidPlatformSettings(
                                    res.config.data
                                )
                            ) {
                                storageService.storeToLocal(
                                    APP_MEMORY_STORAGE_KEY.PLATFORM_SETTINGS,
                                    res.config.data
                                );
                            }
                            return res.data;
                        }
                    }
                }
                //saveGeneralSettings: {
                //    method: 'POST',
                //    url: API_URL.SHIPPER_USER + '/settings/platform'
                //},
                //saveDashboardSettings: {
                //    method: 'POST',
                //    url: API_URL.SHIPPER_USER + '/settings/dashboard'
                //}
            }
        );
    }
})();
